import { Box, Button, Divider, Grid2, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { Route, Routes, useNavigate, useParams } from "react-router-dom";
import { ClosingChecklistListTypeEnum } from "../../../_common/enum/closingChecklistListType.enum";
import { StandardList } from "../../../_components/list/standardList.component";
import { StandardListItem } from "../../../_components/list/standardListItem.component";
import { getDateFromString } from "../../../_helpers/dateTime.helper";
import { handleErrorResponse } from "../../../_helpers/handleResponse.helper";
import { ticketClosingChecklistService } from "../../../_services/ticketClosingChecklist.service";
import { ticketService } from "../../../_services/ticket.service";
import { TicketClosingChecklistClientDrawer } from "./ticket-closingChecklistClinetDrawer";
import { toastr } from "../../../_components/toastr/toastr";


export function TicketClosingChecklistListClient(params: { closingChecklistListTypeId: ClosingChecklistListTypeEnum, paymentDate?: string, invoiceNumber?: string }) {

    const { id, ticketType } = useParams<{ id: string, caseId?: string, ticketType?: string }>();
    const [data, setData] = useState<{ [key: number]: any }>({});
    const [isLoading, setIsLoading] = useState(false);
    const [actions, setActions] = useState<any[]>([]);
    const [clientTicketPrice, setClientTicketPrice] = useState<number | null>(null);
    const navigate = useNavigate();
    const isInvoiced = !!params?.invoiceNumber;

    useEffect(() => {
        if (id != null) {
            fetchData();
            getClientTicketPrice();
        }
        else setData({});
    }, [id]);

    function fetchData() {
        if (!id) return;
        setIsLoading(true);
        return ticketClosingChecklistService
            .getAll(id, params.closingChecklistListTypeId)
            .then(
                (json) => {
                    setActions(json);
                },
                handleErrorResponse
            )
            .finally(() => setIsLoading(false));
    }

    function getClientTicketPrice() {
        if (!id) return;
        return ticketService
            .get(id, ticketType)
            .then(
                (json) => {
                    setClientTicketPrice(json?.clientTicketPrice ?? 0);
                },
                handleErrorResponse
            )
            .finally();
    }

    function disable(id: string) {
        if (!id) return;
        setIsLoading(true);
        return ticketClosingChecklistService
            .disable(id)
            .then(
                () => {
                    toastr.success("Disabled successfully");
                    fetchData();
                },
                handleErrorResponse
            )
            .finally(() => setIsLoading(false));
    }


    return (
        <>
            {actions.map((group, gIndex) => {

                const actionsTotal = group.items.reduce(
                    (sum: number, action: any) =>
                        sum + (Number(action?.price ?? 0) * Number(action?.quantity ?? 1) || 0),
                    0
                );

                const totalWithClient = actionsTotal + (clientTicketPrice || 0);
                return (
                    <Grid2 key={gIndex}>
                        {!isInvoiced &&
                            <Box display="flex" justifyContent="flex-end" my={2}>
                                <Button variant="contained" onClick={() => navigate("ManageClosingChecklistClient/Create")}>
                                    Add List Item
                                </Button>
                            </Box>
                        }
                        <StandardList isLoading={isLoading}>
                            {group.items.map((item: any, index: any) => (
                                <StandardListItem
                                    primary={item.name}
                                    secondary={item?.quantity ? "Qty: " + (item?.quantity) : null}
                                    tertiary={item?.price ? (item?.price).toFixed(2) : null}
                                    buttons={[
                                        { icon: "edit", onClick: () => { navigate(`ManageClosingChecklistClient/Update/${item.id}`) }, variant: "primary", disabled: isInvoiced },
                                        { icon: "delete", onClick: () => { disable(item.id) }, variant: "error", disabled: isInvoiced },

                                    ]}
                                    key={item.id}

                                />
                            ))}

                        </StandardList>
                        {/* Totals */}
                        <Grid2 size={{ xs: 12 }} mt={2}>
                            <Box px={1}>
                                <Typography variant="body1" gutterBottom>
                                    <strong>Ticket Price:</strong> {'\u20AC'}{(clientTicketPrice || 0).toFixed(2)}
                                </Typography>
                                <Typography variant="body1" gutterBottom>
                                    <strong>
                                        Actions:
                                    </strong> {'\u20AC'}{actionsTotal.toFixed(2)}
                                </Typography>

                                <Typography variant="h6" gutterBottom>
                                    <strong>Total:</strong> {'\u20AC'}{totalWithClient.toFixed(2)}
                                </Typography>

                                {params?.invoiceNumber &&
                                    <Typography variant="h6" gutterBottom>
                                        <strong>Invoice Number:</strong> {params?.invoiceNumber}
                                    </Typography>
                                }

                                {params?.paymentDate &&
                                    <Typography variant="h6" gutterBottom>
                                        <strong>Payment Date:</strong> {params?.paymentDate != null ? getDateFromString(params.paymentDate) : ""}
                                    </Typography>
                                }
                            </Box>

                            <Divider sx={{ my: 2 }} />
                        </Grid2>
                    </Grid2>
                )
            })}

            <Routes>
                <Route path="ManageClosingChecklistClient/*" element={<TicketClosingChecklistClientDrawer closingChecklistListTypeId={ClosingChecklistListTypeEnum.Client} onSave={() => { fetchData(); navigate(""); }} onClose={() => { navigate(""); }} />} />
                <Route path="ManageClosingChecklistClient/Update/:checklistItemId*" element={<TicketClosingChecklistClientDrawer closingChecklistListTypeId={ClosingChecklistListTypeEnum.Client} onSave={() => { fetchData(); navigate(""); }} onClose={() => { navigate(""); }} />} />


            </Routes>
        </>
    );

}
